(function () {
  'use strict';

  function formatMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-MY', {
        style: 'currency', currency: currency || 'MYR', maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (error) {
      return (currency || 'MYR') + ' ' + (cents / 100).toFixed(2);
    }
  }

  function initNavigation() {
    var toggle = document.querySelector('[data-okdo-menu-toggle]');
    var menu = document.querySelector('[data-okdo-menu]');
    if (!toggle || !menu || toggle.dataset.okdoReady) return;
    toggle.dataset.okdoReady = 'true';
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      document.body.classList.toggle('okdo-menu-open', !open);
    });
  }

  class OkdoProductExperience extends HTMLElement {
    connectedCallback() {
      if (this.dataset.okdoReady) return;
      this.dataset.okdoReady = 'true';
      this.variants = this.readVariants();
      this.initGallery();
      this.initCommerce();
      this.initFitFinder();
      this.initRecommendations();
      this.initJumpLinks();
    }

    readVariants() {
      var node = this.querySelector('[data-okdo-product-json]');
      try { return node ? JSON.parse(node.textContent) : []; } catch (error) { return []; }
    }

    initGallery() {
      var gallery = this.querySelector('[data-okdo-gallery]');
      if (!gallery) return;
      var image = gallery.querySelector('[data-okdo-gallery-image]');
      var counter = gallery.querySelector('[data-okdo-gallery-counter]');
      var thumbs = Array.from(gallery.querySelectorAll('[data-okdo-gallery-thumb]'));
      if (!image || !thumbs.length) return;

      function activate(button, focus) {
        var mediaSwitch = gallery.querySelector('[data-okdo-media-switch]');
        if (mediaSwitch) mediaSwitch.dispatchEvent(new CustomEvent('okdo:media-reset'));
        thumbs.forEach(function (thumb) {
          var active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
        image.src = button.dataset.mediaSrc;
        image.alt = button.dataset.mediaAlt || image.alt;
        if (counter) counter.textContent = button.dataset.mediaPosition + ' / ' + thumbs.length;
        if (focus) button.focus();
      }

      thumbs.forEach(function (button, index) {
        button.addEventListener('click', function () { activate(button, false); });
        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
          activate(thumbs[next], true);
        });
      });
    }

    initCommerce() {
      var root = this;
      var form = root.querySelector('[data-okdo-product-form]');
      if (!form || !this.variants.length) return;
      var currency = root.dataset.moneyCurrency || 'MYR';
      var labels = {
        add: root.dataset.labelAdd || 'Add to cart', sold: root.dataset.labelSold || 'Sold out',
        unavailable: root.dataset.labelUnavailable || 'Unavailable', stock: 'In stock for Malaysia',
        noStock: root.dataset.labelNoStock || 'Currently unavailable'
      };
      var idInput = form.querySelector('[data-okdo-variant-id]');
      var price = root.querySelector('[data-okdo-price]');
      var stickyPrice = root.querySelector('[data-okdo-sticky-price]');
      var comparePrice = root.querySelector('[data-okdo-compare-price]');
      var stockLine = root.querySelector('[data-okdo-stock-line]');
      var stockLabel = root.querySelector('[data-okdo-stock-label]');
      var addButton = form.querySelector('[data-okdo-add]');
      var addLabel = form.querySelector('[data-okdo-add-label]');
      var buyNow = form.querySelector('[data-okdo-buy-now]');
      var stickyAdd = root.querySelector('[data-okdo-sticky-add]');
      var status = form.querySelector('[data-okdo-form-status]');
      var groups = Array.from(form.querySelectorAll('[data-okdo-option-group]'));
      var variants = this.variants;

      function selectedOptions() {
        return groups.map(function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : '';
        });
      }

      function currentVariant() {
        var options = selectedOptions();
        return variants.find(function (variant) {
          return !options.length || variant.options.every(function (value, index) { return value === options[index]; });
        });
      }

      function updateVariant() {
        var variant = currentVariant();
        groups.forEach(function (group) {
          var checked = group.querySelector('input:checked');
          var output = group.querySelector('[data-okdo-option-value]');
          if (checked && output) output.textContent = checked.value;
        });
        if (!variant) {
          [addButton, buyNow, stickyAdd].forEach(function (button) { if (button) button.disabled = true; });
          if (addLabel) addLabel.textContent = labels.unavailable;
          if (status) status.textContent = 'This option combination is unavailable.';
          return;
        }
        idInput.value = variant.id;
        var formatted = formatMoney(variant.price, currency);
        if (price) price.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = formatted;
        if (comparePrice) {
          var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          comparePrice.hidden = !showCompare;
          comparePrice.textContent = showCompare ? formatMoney(variant.compare_at_price, currency) : '';
        }
        [addButton, buyNow, stickyAdd].forEach(function (button) { if (button) button.disabled = !variant.available; });
        if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.sold;
        if (stockLine) stockLine.classList.toggle('is-unavailable', !variant.available);
        if (stockLabel) stockLabel.textContent = variant.available ? labels.stock : labels.noStock;
        if (status) status.textContent = '';
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      function setBusy(busy) {
        form.setAttribute('aria-busy', String(busy));
        if (addButton) addButton.disabled = busy;
        if (buyNow) buyNow.disabled = busy;
        if (stickyAdd) stickyAdd.disabled = busy;
      }

      function addToCart(checkout) {
        if (!idInput.value) return;
        setBusy(true);
        if (status) status.textContent = checkout ? 'Preparing secure checkout…' : 'Adding to cart…';
        var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(rootPath + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form)
        }).then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
          return response.json();
        }).then(function () {
          if (checkout) return window.location.assign(rootPath + 'checkout');
          if (status) status.innerHTML = 'Added to cart. <a href="' + rootPath + 'cart">View cart</a>';
          setBusy(false);
          updateVariant();
        }).catch(function (error) {
          if (status) status.textContent = error.message || 'Unable to add this item.';
          setBusy(false);
          updateVariant();
        });
      }

      groups.forEach(function (group) { group.addEventListener('change', updateVariant); });
      form.addEventListener('submit', function (event) { event.preventDefault(); addToCart(false); });
      if (buyNow) buyNow.addEventListener('click', function () { addToCart(true); });
      if (stickyAdd) stickyAdd.addEventListener('click', function () { form.requestSubmit(addButton); });
      updateVariant();
    }

    initFitFinder() {
      var finder = this.querySelector('[data-okdo-fit-finder]');
      if (!finder) return;
      var form = finder.querySelector('[data-okdo-fit-form]');
      var output = finder.querySelector('[data-okdo-fit-result]');
      var allowed = {
        use: (finder.dataset.fitCases || '').split(','), daily: (finder.dataset.fitDaily || '').split(','),
        priority: (finder.dataset.fitPriorities || '').split(',')
      };
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var values = Object.fromEntries(new FormData(form));
        var matches = ['use', 'daily', 'priority'].filter(function (key) { return allowed[key].includes(values[key]); }).length;
        if (matches === 3) output.innerHTML = '<strong>Strong match.</strong> This model aligns with all three selected needs. Review the dimensions and choose your variant.';
        else if (matches === 2) output.innerHTML = '<strong>Good match.</strong> It supports two of your priorities. Compare the alternatives below before ordering.';
        else output.innerHTML = '<strong>Consider another model.</strong> Your routine only matches one listed strength. Use the comparison cards or ask OKDO for guidance.';
      });
    }

    initRecommendations() {
      var container = this.querySelector('[data-okdo-recommendations]');
      if (!container || container.children.length || !container.dataset.recommendationsUrl) return;
      fetch(container.dataset.recommendationsUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('Recommendations unavailable')); })
        .then(function (data) {
          var products = (data.products || []).slice(0, 4);
          if (!products.length) return;
          products.forEach(function (product) {
            var article = document.createElement('article');
            article.className = 'okdo-related-card';
            var link = document.createElement('a');
            link.href = product.url;
            var title = document.createElement('h3');
            title.textContent = product.title;
            var price = document.createElement('strong');
            price.textContent = formatMoney(product.price, 'MYR');
            link.append(title, price);
            article.append(link);
            container.append(article);
          });
        }).catch(function () { container.hidden = true; });
    }

    initJumpLinks() {
      this.querySelectorAll('.okdo-product-jump a').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.querySelector(link.hash);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
    }
  }

  if (!customElements.get('okdo-product-experience')) customElements.define('okdo-product-experience', OkdoProductExperience);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNavigation);
  else initNavigation();
})();
